import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import {AssignAccountsToPortfolioDialogComponent} from "@irb/irb-clients/assign-accounts-to-portfolio-dialog/assign-accounts-to-portfolio-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class AssignAccountsToPortfolioDialogGridLayoutService implements GridLayoutService<AssignAccountsToPortfolioDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Account Number',
            field: 'accountNumber',
            maxWidth: 150,
            width: 150,
            sort:'asc'
        },
            {
                headerName: 'Account Name',
                field: 'accountName',
                maxWidth: 321,
                width: 321
            },
            {
                headerName: 'Account Type',
                field: 'accountType',
                maxWidth: 120,
                width: 120
            }];
    }
}
